import React, { useState } from "react";
import { Button, Card, Col, Row, Stack } from "react-bootstrap";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import SelectObject from "../../ui/SelectObject";
import { postField } from "../../../services/httpClient";
import IconEmbeddedButton from "../../ui/IconEmbeddedButton";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FieldCards from "./FieldCards";

interface FieldsState {
  fields: any;
  getFields: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  showAddField: boolean;
  setShowAddField: (value: boolean) => void;
}

const Fields = ({
  fields,
  getFields,
  setOrgToSave,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
  showAddField,
  setShowAddField,
}: FieldsState) => {
  const [newLabel, setNewLabel] = useState<string>("");
  const [newType, setNewType] = useState<string>("");

  const fieldOptions = [
    { key: "checkbox", name: "Checkbox" },
    { key: "date", name: "Date" },
    { key: "text", name: "Text" },
    { key: "multi-line text", name: "Multi-Line Text" },
  ];

  const onClickAddField = () => {
    setShowAddField(true);
  };

  const updateNewLabel = (e: any) => {
    setNewLabel(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewType = (e: any) => {
    setNewType(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveField = (isDone: boolean = false) => {
    const newField = {
      label: newLabel,
      type: newType,
    };

    setErrMessage("");

    postField(newField)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Field Created");
        setToastBody(newLabel);
        setNewLabel("");
        setNewType("");
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setShowAddField(false);
        }
        getFields();
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });

    // trackFeatureEvent("button_click", "create_custom_field");
  };

  const onClickCancelAddField = () => {
    setErrMessage("");
    setShowAddField(false);
    setNewLabel("");
    setNewType("");
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  const renderAddField = () => {
    return (
      <>
        <Row className="align-items-center mb-3">
          <Col xs={6}>
            <Input label="Label" type="text" value={newLabel} onUpdate={(e: any) => updateNewLabel(e)} hasFocus={true} required={true} />
          </Col>
          <Col xs={6}>
            <SelectObject label="Type" value={newType} options={fieldOptions} onUpdate={(e: any) => updateNewType(e)} required={true} />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={12}>
            <Stack direction="horizontal" gap={3}>
              <Button
                className="app-secondary-color button"
                disabled={!newLabel || !newType || newType === "0"}
                onClick={() => onClickSaveField(false)}
              >
                Save and Add Another
              </Button>
              <div className="vr" />
              <Button
                className="app-secondary-color button"
                disabled={!newLabel || !newType || newType === "0"}
                onClick={() => onClickSaveField(true)}
              >
                Save and Done
              </Button>
              <div className="vr" />
              <Button className="app-primary-color button" onClick={() => onClickCancelAddField()}>
                Done
              </Button>
            </Stack>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {fields.length === 0 ? (
        <>
          <p className="mt-2">No Field Records</p>
          {showAddField && <>{renderAddField()}</>}
        </>
      ) : (
        <Row>
          <Col xs={12}>
            <Card key={0} className="p-3 bg-light">
              <Row className="mb-3">
                <Col xs={9}>
                  <h6 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{"Custom Fields"}</h6>
                </Col>
                <Col xs={3} className="d-flex justify-content-end">
                  <Stack direction="horizontal" gap={2}>
                    <IconEmbeddedButton onClickButton={onClickAddField} tooltipText={"Add Field"} icon={faPlus} />
                  </Stack>
                </Col>
              </Row>
              {showAddField === true && <>{renderAddField()}</>}
              <FieldCards
                key={0}
                fields={fields}
                getFields={getFields}
                setOrgToSave={setOrgToSave}
                setErrMessage={setErrMessage}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
              />
            </Card>
          </Col>
        </Row>
      )}

      <Row className="mb-5"></Row>
    </>
  );
};

export default Fields;
